import React from 'react';
import { TrendingUp, Calendar, BookOpen, Users, BarChart3, ArrowRight } from 'lucide-react';

const ToolSelector = ({ onSelectTool }) => {
  const tools = [
    {
      id: 'cgpa',
      title: 'CGPA Calculator',
      description: 'Calculate your cumulative GPA across all semesters',
      icon: TrendingUp,
      gradient: 'from-indigo-500 to-purple-600',
      example: 'Track your overall progress'
    },
    {
      id: 'semester',
      title: 'Semester GPA',
      description: 'Calculate GPA for your current or any specific semester',
      icon: Calendar,
      gradient: 'from-blue-500 to-cyan-600',
      example: 'Enter subject grades and credit hours'
    },
    {
      id: 'theory',
      title: 'Theory Subject GPA',
      description: 'Calculate GPA for a single theory course from components',
      icon: BookOpen,
      gradient: 'from-emerald-500 to-teal-600',
      example: 'Assignments, quizzes, midterm & final'
    },
    {
      id: 'lab',
      title: 'Lab Subject GPA',
      description: 'Combined GPA for subjects with theory and lab components',
      icon: Users,
      gradient: 'from-violet-500 to-indigo-600',
      example: 'Weighted calculation for lab courses'
    },
    {
      id: 'percentage',
      title: 'Percentage Tools',
      description: 'Convert between marks and percentages both ways',
      icon: BarChart3,
      gradient: 'from-pink-500 to-rose-600',
      example: 'Two-way conversion calculator'
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tools.map((tool) => {
        const Icon = tool.icon;
        return (
          <button
            key={tool.id}
            onClick={() => onSelectTool(tool.id)}
            className="group relative bg-white dark:bg-slate-900 rounded-3xl p-6 border-2 border-slate-100 dark:border-slate-800 hover:border-transparent hover:shadow-2xl transition-all duration-300 text-left overflow-hidden"
          >
            {/* Gradient Background on Hover */}
            <div className={`absolute inset-0 bg-gradient-to-br ${tool.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
            
            {/* Content */}
            <div className="relative z-10">
              <div className="flex items-start justify-between mb-4">
                <div className={`p-3 rounded-2xl bg-gradient-to-br ${tool.gradient} text-white shadow-lg`}>
                  <Icon size={24} />
                </div>
                <ArrowRight 
                  size={20} 
                  className="text-slate-400 dark:text-slate-600 group-hover:text-white group-hover:translate-x-1 transition-all" 
                />
              </div>
              
              <h3 className="text-lg font-bold text-slate-900 dark:text-white group-hover:text-white mb-2 transition-colors">
                {tool.title}
              </h3>
              
              <p className="text-sm text-slate-600 dark:text-slate-400 group-hover:text-white/90 mb-3 transition-colors">
                {tool.description}
              </p>
              
              <div className="flex items-center gap-2 text-xs font-medium text-slate-400 dark:text-slate-500 group-hover:text-white/70 transition-colors">
                <div className="w-1.5 h-1.5 rounded-full bg-current" />
                <span>{tool.example}</span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ToolSelector;
